import React from "react";
import PropTypes from "prop-types";

/**
 * Componente AcordeaoItem
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {string} props.id - O ID do item de acordeão.
 * @param {string} props.titulo - O título do item de acordeão.
 * @param {boolean} [props.ativo=false] - Indica se o item de acordeão está ativo ou não.
 * @param {ReactNode} props.children - O conteúdo a ser exibido quando o item de acordeão estiver expandido.
 * @returns {ReactElement} O elemento React renderizado que representa um item de acordeão.
 */
function AcordeaoItem({ id, titulo, ativo = false, children, divprops = {} }) {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={`flush-heading${id}`}>
        <button
          className={`accordion-button fw-medium ${ativo ? "" : "collapsed"}`}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#flush-collapse${id}`}
          aria-expanded={ativo ? "true" : "false"}
          aria-controls={`flush-collapse${id}`}
        >
          {titulo}
        </button>
      </h2>
      <div
        id={`flush-collapse${id}`}
        className={`accordion-collapse collapse ${ativo ? "show" : ""}`}
        aria-labelledby={`flush-heading${id}`}
        data-bs-parent="#accordionFlush"
        {...divprops}
      >
        <div className="accordion-body text-muted">{children}</div>
      </div>
    </div>
  );
}

AcordeaoItem.propTypes = {
  id: PropTypes.string.isRequired,
  titulo: PropTypes.string.isRequired,
  ativo: PropTypes.bool,
  divprops: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default AcordeaoItem;
